module.exports = __webpack_public_path__ + "files/c45224e7de5d12d4d0d4813b7e61daf2.svg";